module.exports = __webpack_public_path__ + "static/img/medium_bg.2f71216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logisticsBigData/medium_bg.png
// module id = QF+2
// module chunks = 44